import React, { useEffect } from "react";
import { ReportSummaryItemApi } from "../api/Reports";
import {
  useReportDetail,
  useReportTimer,
} from "../reports/ReportDetailProvider";
import { ManualAddProfilesQA } from "./ManualAddProfilesQA";
import ProfileDisplay from "./ProfileDisplay";

import LoadingSpinner from "../shared-components/LoadingSpinner";

function AuditQAProfiles({
  report,
  isLoadingCreateProfile,
  setNewProfiles,
}: {
  report: ReportSummaryItemApi;
  isLoadingCreateProfile: boolean;
  setNewProfiles: (profiles: string[]) => void;
}) {
  const { profileList, isSuccessProfiles } = useReportDetail();
  const { resetTimer } = useReportTimer();

  useEffect(() => {
    if (isSuccessProfiles) {
      resetTimer?.();
    }
  }, [isSuccessProfiles, resetTimer]);

  return (
    <div>
      <div>
        <div className="mx-auto rounded-lg p-4 bg-gray-50 shadow-sm border-gray-200">
          <div className="font-semibold">Confirmed Profiles</div>
          {(!profileList || profileList.length === 0) && (
            <div className="text-gray-500 text-sm py-2">
              No Profiles Confirmed
            </div>
          )}
          {profileList && profileList.length > 0 && (
            <ProfileDisplay
              profileList={profileList}
              isSidebar={false}
              showAddedBy={true}
            />
          )}
        </div>
        <div>
          <ManualAddProfilesQA
            existingProfiles={profileList ?? []}
            setNewProfiles={setNewProfiles}
          />
        </div>
      </div>

      {isLoadingCreateProfile && <LoadingSpinner />}
    </div>
  );
}

export default AuditQAProfiles;
